// Helpers puros compartilhados pelos componentes do Dashboard.

export const COLOR_PALETTE = [
  'rgb(66, 133, 244)',
  'rgb(219, 68, 55)',
  'rgb(80, 158, 89)',
  'rgb(244, 180, 53)',
  'rgb(173, 91, 188)',
  'rgb(36, 34, 132)',
  'rgb(137, 22, 29)',
  'rgb(240, 109, 64)',
  'rgb(158, 157, 36)',
  'rgb(236, 97, 146)',
  'rgb(53, 122, 108)',
  'rgb(38, 235, 242)',
  'rgb(255, 234, 10)',
  'rgb(255, 150, 150)',
  'rgb(132, 26, 125)',
  'rgb(34, 229, 109)',
  'rgb(157, 158, 113)',
  'rgb(232, 0, 58)',
  'rgb(179, 226, 70)'
]

export const STATUS_COLORS = {
  'Atendida': '#3B82F6',
  'Cancelada': '#EF4444',
  'Rejeitada': '#991B1B',
  'Não atendida': '#111827',
  'Caixa postal': '#F59E0B',
  'Número não encontrado': '#9CA3AF',
  'Não foi possível completar': '#6B7280',
  'Barrada': '#D1D5DB',
  'Ocupado': '#8B5CF6',
  'Temporariamente indisponível': '#C4B5FD',
  'Fora de área': '#6D28D9',
  'Redirecionada': '#14B8A6',
  'Corrida perdida': '#DB2777'
}

export const UNMAPPED_STATUS_COLOR = '#64748B'

export function statusColor (label) {
  if (Object.prototype.hasOwnProperty.call(STATUS_COLORS, label)) {
    return STATUS_COLORS[label]
  }
  return UNMAPPED_STATUS_COLOR
}

export const GRANULARITY_LEVELS = ['ano', 'mes', 'semana', 'dia', 'hora']

export const GRANULARITY_LABELS = {
  ano: 'Ano',
  mes: 'Mês',
  semana: 'Semana',
  dia: 'Dia',
  hora: 'Hora'
}

export const parse2Digits = (number) => ('0' + number).slice(-2)

export function secondsToTimeParser (seconds) {
  const twoDigitsParser = (value) => {
    if (value < 10) {
      return `0${value}`.substr(-2)
    } else {
      return value
    }
  }
  seconds = parseInt(seconds)
  const hours = parseInt(seconds / 3600)
  seconds = seconds % 3600
  const minutes = parseInt(seconds / 60)
  seconds = seconds % 60
  return `${twoDigitsParser(hours)}:${twoDigitsParser(minutes)}:${twoDigitsParser(seconds)}`
}

// Paciência: segundos quando < 1min, senão min:seg.
export function formatPatience (seconds) {
  if (!seconds || seconds <= 0) return '—'
  if (seconds < 60) return `${seconds}s`
  const minutes = Math.floor(seconds / 60)
  const rest = seconds % 60
  return `${minutes}:${parse2Digits(rest)}`
}

function formatIsoDateAsBrazilian (iso) {
  const [year, month, day] = iso.slice(0, 10).split('-')
  return `${day}/${month}/${year}`
}

export function formatPeriodLabel (filterDate, filterDateOptions) {
  const period = JSON.parse(filterDate)
  if (period.name === 'custom') {
    return `${formatIsoDateAsBrazilian(period.startedAt)} — ${formatIsoDateAsBrazilian(period.endedAt)}`
  }
  const option = filterDateOptions.find(item => item.value === filterDate)
  return option ? option.text : 'Período'
}

export function formatReportTimestamp (date) {
  const day = parse2Digits(date.getDate())
  const month = parse2Digits(date.getMonth() + 1)
  const hours = parse2Digits(date.getHours())
  const minutes = parse2Digits(date.getMinutes())
  return `${day}/${month}/${date.getFullYear()} às ${hours}:${minutes}`
}

export function formatIsoDay (date) {
  return `${date.getFullYear()}-${parse2Digits(date.getMonth() + 1)}-${parse2Digits(date.getDate())}`
}

// Tooltip custom dos charts: div em document.body com position fixed, pra sobrepor cards.
export function renderDashboardChartTooltip (tooltipModel) {
  const TOOLTIP_ID = 'dashboard-chart-tooltip'
  let el = document.getElementById(TOOLTIP_ID)
  if (!el) {
    el = document.createElement('div')
    el.id = TOOLTIP_ID
    el.className = 'dashboard-chart-tooltip'
    document.body.appendChild(el)
  }
  if (!tooltipModel || tooltipModel.opacity === 0) {
    el.style.opacity = 0
    return
  }
  let title = (tooltipModel.title || []).join(' ')
  const pointTotal = (tooltipModel.dataPoints || []).reduce((sum, p) => sum + (Number(p.yLabel) || 0), 0)
  if (tooltipModel.dataPoints && tooltipModel.dataPoints.length) {
    title += ' — ' + pointTotal + ' chamadas'
  }
  let bodyHtml = ''
  ;(tooltipModel.body || []).forEach((item, i) => {
    const colors = (tooltipModel.labelColors && tooltipModel.labelColors[i]) || {
      backgroundColor: '#ccc',
      borderColor: '#999'
    }
    const line = (item.lines || []).join(' ')
    bodyHtml +=
      '<div class="row"><span class="swatch" style="background:' +
      colors.backgroundColor +
      ';border-color:' +
      colors.borderColor +
      ';"></span><span class="label">' +
      line +
      '</span></div>'
  })
  el.innerHTML = '<div class="title">' + title + '</div>' + bodyHtml
  const canvas = this && this._chart && this._chart.canvas
  const rect = canvas ? canvas.getBoundingClientRect() : { left: 0, top: 0 }
  el.style.opacity = 1
  el.style.left = rect.left + tooltipModel.caretX + 'px'
  el.style.top = rect.top + tooltipModel.caretY + 'px'
  el.style.transform = 'translate(-50%, calc(-100% - 12px))'
}

// Aplica os defaults de tooltip/fonte dos charts do dashboard (uma vez por mount do container).
export function applyChartDefaults (Chart) {
  Chart.defaults.global.defaultFontFamily = "'Inter', ui-sans-serif, system-ui, sans-serif"
  Chart.defaults.global.tooltips.backgroundColor = '#0f172a'
  Chart.defaults.global.tooltips.titleFontFamily = "'Inter', sans-serif"
  Chart.defaults.global.tooltips.titleFontSize = 14
  Chart.defaults.global.tooltips.titleFontStyle = '600'
  Chart.defaults.global.tooltips.titleAlign = 'center'
  Chart.defaults.global.tooltips.titleMarginBottom = 8
  Chart.defaults.global.tooltips.bodyFontFamily = "'Inter', sans-serif"
  Chart.defaults.global.tooltips.bodyFontSize = 12
  Chart.defaults.global.tooltips.bodyFontColor = '#ffffff'
  Chart.defaults.global.tooltips.xPadding = 12
  Chart.defaults.global.tooltips.yPadding = 10
  Chart.defaults.global.tooltips.cornerRadius = 8
  Chart.defaults.global.tooltips.displayColors = true
  Chart.defaults.global.tooltips.borderWidth = 0
  Chart.defaults.global.tooltips.caretSize = 6
}

// Constrói as opções do filtro de período (presets) calculadas no momento da chamada.
export function buildPeriodPresets () {
  const startOfDayIso = (date) => `${date.getFullYear()}-${parse2Digits(date.getMonth() + 1)}-${parse2Digits(date.getDate())}T00:00:00.000Z`
  const endOfDayIso = (date) => `${date.getFullYear()}-${parse2Digits(date.getMonth() + 1)}-${parse2Digits(date.getDate())}T23:59:59.999Z`

  const today = () => ({
    name: 'today',
    startedAt: startOfDayIso(new Date()),
    endedAt: endOfDayIso(new Date()),
    refreshTime: 30,
    refreshCount: 30
  })
  const yesterday = () => {
    const start = new Date()
    start.setDate(start.getDate() - 1)
    return {
      name: 'yesterday',
      startedAt: startOfDayIso(start),
      endedAt: endOfDayIso(start),
      refreshTime: 30,
      refreshCount: 30
    }
  }
  const lastSevenDays = () => {
    const start = new Date()
    start.setDate(start.getDate() - 7)
    return {
      name: 'lastSevenDays',
      startedAt: startOfDayIso(start),
      endedAt: endOfDayIso(new Date()),
      refreshTime: 60,
      refreshCount: 60
    }
  }
  const lastThirtyDays = () => {
    const start = new Date()
    start.setDate(start.getDate() - 30)
    return {
      name: 'lastThirtyDays',
      startedAt: startOfDayIso(start),
      endedAt: endOfDayIso(new Date()),
      refreshTime: 300,
      refreshCount: 300
    }
  }
  const thisWeek = () => {
    const start = new Date()
    const day = start.getDay()
    start.setDate(start.getDate() - (day === 0 ? 6 : day - 1))
    return {
      name: 'thisWeek',
      startedAt: startOfDayIso(start),
      endedAt: endOfDayIso(new Date()),
      refreshTime: 60,
      refreshCount: 60
    }
  }
  const thisMonth = () => {
    const now = new Date()
    const start = new Date(now.getFullYear(), now.getMonth(), 1)
    return {
      name: 'thisMonth',
      startedAt: startOfDayIso(start),
      endedAt: endOfDayIso(new Date()),
      refreshTime: 300,
      refreshCount: 300
    }
  }
  const lastMonth = () => {
    const now = new Date()
    const start = new Date(now.getFullYear(), now.getMonth() - 1, 1)
    const end = new Date(now.getFullYear(), now.getMonth(), 0)
    return {
      name: 'lastMonth',
      startedAt: startOfDayIso(start),
      endedAt: endOfDayIso(end),
      refreshTime: 300,
      refreshCount: 300
    }
  }

  return [
    { text: 'Hoje', value: JSON.stringify(today()) },
    { text: 'Ontem', value: JSON.stringify(yesterday()) },
    { text: 'Últimos 7 dias', value: JSON.stringify(lastSevenDays()) },
    { text: 'Últimos 30 dias', value: JSON.stringify(lastThirtyDays()) },
    { text: 'Esta semana', value: JSON.stringify(thisWeek()) },
    { text: 'Este mês', value: JSON.stringify(thisMonth()) },
    { text: 'Mês passado', value: JSON.stringify(lastMonth()) }
  ]
}

export const CALL_TYPE_OPTIONS = [
  { text: 'Ambas', value: JSON.stringify({ name: 'all', callType: null }) },
  { text: 'Saínte', value: JSON.stringify({ name: 'outbound', callType: 'outbound' }) },
  { text: 'Entrante', value: JSON.stringify({ name: 'inbound', callType: 'inbound' }) }
]



// WEBPACK FOOTER //
// ./src/components/Dashboard/dashboard-helpers.js